export default __webpack_public_path__ + "static/media/ST.92e426aa.svg";